import type { ReactNode } from 'react';

/**
 * FE-1-9 — one layout shared by sign-in, invite-accept and password-reset, so those
 * three pages cannot drift apart visually.
 */
export function AuthLayout({
  title,
  subtitle,
  children,
  footer,
}: {
  title: string;
  subtitle?: string;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-canvas px-4 py-10">
      <main id="main" className="w-full max-w-[400px]">
        <div className="mb-7 flex flex-col items-center text-center">
          <span
            className="mb-3 flex h-11 w-11 items-center justify-center rounded-card bg-accent text-xl font-bold text-[#0F1319]"
            aria-hidden="true"
          >
            A
          </span>
          <h1 className="text-lg font-semibold text-ink">{title}</h1>
          {subtitle && <p className="mt-1.5 text-sm leading-relaxed text-muted">{subtitle}</p>}
        </div>

        <div className="card p-6">{children}</div>

        {footer && <div className="mt-5 text-center text-sm text-muted">{footer}</div>}

        <p className="mt-8 text-center text-xs text-muted">
          Ambition · Daily Leadership Signal
        </p>
      </main>
    </div>
  );
}
